<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper" ref="formContainer">
      <!-- Page Content -->
      <div class="content container-fluid">
        <!-- Page Header -->
        <inbox-header :title="title" :path="path" :text="text" />
        <!-- /Page Header -->

        <!-- Search Filter -->
        <user-permission-filter
          @reload-data="searchData"
        ></user-permission-filter>
        <!-- /Search Filter -->

        <div class="row">
          <div class="col-md-12">
            <div class="showentries mb-3">
              <label
                >Show
                <select v-model="pagination.pageSize" @change="updatePerPage">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries</label
              >
            </div>
            <div class="table-responsive">
              <a-table
                class="stripped table-hover"
                :columns="columns"
                :data-source="Employees"
                :pagination="pagination"
                @change="handleTableChange"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'first_name'">
                    <h2 class="table-avatar">
                      <router-link :to="'profile/' + record?.id" class="avatar">
                        <img
                          v-if="record?.avatar"
                          :src="getEmployeeAvatar(record.avatar)"
                          alt="User Image"
                          @error="handleImageError(record)"
                        />
                        <img
                          v-else
                          :src="
                            require(`@/assets/img/profiles/${defaultAvatar}`)
                          "
                          alt="User Image"
                        />
                      </router-link>
                      <router-link :to="'profile/' + record?.id"
                        >{{ record?.first_name }} {{ record?.last_name }}
                        <span>- {{ record?.employee_id }}</span></router-link
                      >
                    </h2>
                  </template>
                  <template v-else-if="column.key === 'role'">
                    {{ record?.designation?.name || "-" }}
                  </template>
                  <template v-else-if="column.key === 'department'">
                    {{ record?.department?.name || "-" }}
                  </template>
                  <template v-else-if="column.key === 'action'">
                    <a
                      class=""
                      href="javascript:;"
                      data-bs-toggle="modal"
                      data-bs-target="#user_permission"
                      @click="employee(record)"
                      ><i class="fa-solid fa-pencil m-r-5"></i
                    ></a>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->

      <user-permission-model
        :employeeData="employeeData"
        @reloadEmp="loadCommonData"
        :clearEMP="clearEMP"
      ></user-permission-model>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { notification } from "ant-design-vue";
import axios from "axios";

var pagination = { total: 0, current: 1, pageSize: 10 };

const columns = [
  {
    title: "Name",
    dataIndex: "first_name",
    key: "first_name",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Position",
    dataIndex: "role",
    key: "role",
  },
  {
    title: "Department",
    dataIndex: "department",
    key: "department",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
  },
];

export default {
  data() {
    return {
      clearEMP: false,
      columns: columns,
      // data,
      title: "User Permissions",
      path: "Dashboard",
      text: "User Permissions",
      defaultAvatar: "avatar-01.jpg",
      employeeData: null,
      hasEditPermission: null,
      hasDeletePermission: null,
      hasReadPermission: null,
      perpage: 10,
      pagination: pagination,
      Employees: [],
      Designations: [],
      currentFilters: {
        s_employee_id: null,
        designation_id: null,
        dept_id: null,
      },
    };
  },
  computed: {
    ...mapGetters(["getEmployees"]),
  },
  methods: {
    ...mapActions(["fetchEmployees", "setEmployeeData"]),
    clearEmployeeData() {
      this.clearEMP = false;
      this.$nextTick(() => {
        this.clearEMP = true;
      });
    },
    searchData(searchData) {
      var params = {
        params: { per_page: this.pagination.pageSize },
      };

      this.loadCommonData(params, searchData);
    },
    loadCommonData(params, searchData = null) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      if (params == null) {
        params = {
          params: {
            per_page: this.pagination.pageSize,
            page: this.pagination.current,
          },
        };
      }

      var getQuery = "/employee";
      let queryParams = {
        ...params.params,
        ...this.currentFilters,
      };
      if (searchData != null) {
        this.currentFilters = {
          s_employee_id: searchData.s_employee_id,
          designation_id: searchData.designation_id,
          dept_id: searchData.department_id,
        };
        queryParams = { ...queryParams, ...this.currentFilters };
      }

      // if (searchData != null) {
      //   getQuery =
      //     "/employee?s_employee_id=" +
      //     searchData.s_employee_id +
      //     "&designation_id=" +
      //     searchData.designation_id +
      //     // "&status=" +
      //     // searchData.status +
      //     "&dept_id=" +
      //     searchData.department_id;
      // }

      axios
        .get(getQuery, { params: queryParams })
        .then((response) => {
          loader.hide();
          this.pagination.total = response.data.data.record.total;
          this.pagination.current = response.data.data.record.current_page;
          this.pagination.pageSize = response.data.data.record.per_page;

          this.Employees = response.data.data.record.data || [];
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    handleTableChange(pagesize) {
      var params = {
        params: { per_page: pagesize.pageSize, page: pagesize.current },
      };

      this.loadCommonData(params);
    },
    updatePerPage() {
      var params = {
        params: { per_page: this.pagination.pageSize },
      };
      this.loadCommonData(params);
    },
    employee(employee) {
      this.setEmployeeData(employee);
      this.$nextTick(() => {
        this.employeeData = employee;
      });
    },
    getEmployeeAvatar(avatar) {
      return `${process.env.VUE_APP_IMAGE_BASE_URL}${avatar}`;
    },
    handleImageError(record) {
      record.avatar = null;
      record.avatar = `assets/img/profiles/${this.defaultAvatar}`;
    },
    getDesignation() {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("designations/all")
        .then((response) => {
          this.Designations = response?.data?.data || [];
        })
        .catch((error) => {
          console.log("error during getting designation : ", error);
        });
    },
  },
  mounted() {
    // let loader = this.$loading.show({
    //   // Optional parameters
    //   container: this.$refs.formContainer,
    //   canCancel: false,
    // });
    this.updatePerPage();
    this.getDesignation();
    // loader.hide();
  },
};
</script>
